export default __webpack_public_path__ + "static/media/3.d43355d6.png";